const translateContactsLabel = {
  TELEPHONE: 'Telefone',
  EMAIL: 'E-mail'
}

export default translateContactsLabel
